// 唯一标识来源
export const RummyMessageFrom = {
  KBP_SCHEME: 'kbpscheme',
  COMEE_SCHEME: 'comescheme',
  FANTASY_SCHEME: 'fantasycheme',
};

export enum RummyMessageType {
  // 登录、注册
  KBP_REGISTER = 'kbpregister',
  // 打开充值
  KBP_OPEN_SHOP = 'kbpopenshop',
  // 是否需要隐藏tab
  KBP_HIDE_TAB = 'kbphidenavigation',
  // 保存图片
  KBP_SAVE_IMAGE = 'kbpsaveimage',
  // 三方分享
  KBP_SHARE = 'kbpsharelink',
  // 复制到剪贴板
  KBP_COPY_TO_CLIPBOARD = 'kbpcopytoclipboard',
  // token失效
  TOKEN_INVALID = 'tokeninvalid',
  // rummy 初始化成功，就说明已经进入rummy大厅了
  KBP_INIT_SUCCESS = 'kbpinitsuccess',
  // 跳转外链
  OPEN_URL = "openurl",
  // 免费次数
  KBP_FREE_NUM = 'freenum',
  // loaded_url
  LOADED_URL = 'loaded_url',
  // rummy加载资源信息
  LOADED_RESOURCES = 'loaded_resources',
}

export enum ComeToRummyType {
  // 激活true，切入后台false
  GAME_SHOW = 'gameshow',
  // 跳转子页面
  JUMP_SUBPAGE = 'jumpsubpage',
  // rummy加载资源信息
  LOADED_RESOURCES = 'loaded_resources',
}

export enum RummySubPage {
  // 跳转cash
  RUMMY_CASH = 7,
  // 跳转赛事
  RUMMY_MATCH = 3,
}

export interface KbpOpenShopParams {
  // 充值字符串，跟踪充值来源
  depositStr: string;
}

export interface KbpHideTabParams {
  // 是否需要隐藏tab
  hide: boolean;
}

export interface KbpSaveImageParams {
  // 图片base64
  imgBase64: string;
  // 分享链接
  url: string;
}

export interface OpenUrlParams {
  // 跳转外链
  url: string;
}

export enum KbpShareType {
  FACEBOOK = 'facebook',
  WHATSAPP = 'whatsapp',
  TELEGRAM = 'telegram',
  DISCORD = 'discord',
}

export interface KbpShareParams {
  // 分享链接
  desc: string;
  link: string;
  type: KbpShareType;
}

export interface KbpCopyToClipboardParams {
  // 复制到剪贴板
  context: string;
  // 分享链接
  url: string;
}

export interface KbpFreeNum {
  // 免费次数
  num: number;
}


export interface RummyMessageData {
  from: string;
  params: Record<string, KbpOpenShopParams | KbpHideTabParams | KbpSaveImageParams | KbpShareParams>;
  type: RummyMessageType;
}